<form [formGroup]="formGroup" (ngSubmit)="submit()" class="form-group entry-form" autocomplete="off">
    <div>

        <ng-container *ngIf="_responsive.isMobile()">
            <div class="selfie-photo-grid">
                <div class="selfie-photo-wrapper" *ngIf="state.imageData">
                    <img [src]="state.imageData" alt="selfie photo" />
                </div>
            </div>

            <div class="doc-result-button-grp">
                <!-- <button type="button" class="upload-btn" (click)="_helper.douploadPhoto()"><span
                        class="uploadlab">Upload</span></button> 
                <button type="button" class="retake-btn btn-link" (click)="_helper.retakePhoto()"><span>Try
                        again</span></button> -->
                <button class="upload-btn" type="button" (click)="_helper.douploadPhoto()">
                    <img *ngIf="state.disableBtn" src="./assets/images/bars-rotate-loader.svg" alt="loading..." />
                    <span class="uploadlab">{{state.disableBtn?'Uploading':'Upload'}}</span>
                </button>
                <button type="button" class="retake-btn btn-link" (click)="_helper.retakePhoto()"><span>Try
                        again</span></button>
                <button type="submit" class="btn-next" [hidden]="!(this.state.faceMatchCheck)"
                    [disabled]="state.isFormSubmitted" [ngClass]="{'on-click': state.isFormSubmitted}">
                    <span *ngIf="!state.isFormSubmitted">next</span>
                    <img *ngIf="state.isFormSubmitted" src="./assets/images/bars-rotate-loader.svg" alt="loading..." />
                    <span *ngIf="state.isFormSubmitted">Processing</span>
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="_responsive.isDesktop()">
            <div class="title-sec">
                <div class="close-btn">
                    <button class="popup-close" clickable (click)="closePopup()">
                        <svg  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-hij-c418="" d="M12 4L4 12" stroke="#004A63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-hij-c418="" d="M4 4L12 12" stroke="#004A63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </button>
                        <span>Close</span>
                </div>
                <div class="divider">|</div>
                <div class="title-div">
                    <span class="title">Upload Photo</span>
                </div>
            </div>
            
            <div class="sub-title-div">
                <span class="title-description">Place the picture inside green circle</span>
            </div>
            <div class="selfie-photo-grid">
                <div class="selfie-photo-wrapper" *ngIf="state.imageData">
                    <img [src]="state.imageData" alt="selfie photo" />
                </div>
            </div>
            <!-- <div class="doc-result-button-grp">
                <button type="button" class="upload-btn" (click)="_helper.douploadPhoto()"><span
                        class="uploadlab">Upload</span></button>
                <button type="button" class="retake-btn btn-link" (click)="_helper.retakePhoto()"><span>Try
                        again</span></button>
            </div> -->


            <div class="doc-result-button-grp">
                 <!-- <button type="button" class="upload-btn" (click)="_helper.douploadPhoto()"><span
                             class="uploadlab">Upload</span></button> -->
                <button class="upload-btn" type="button" (click)="_helper.douploadPhoto()">
                    <img *ngIf="state.disableBtn" src="./assets/images/bars-rotate-loader.svg" alt="loading..." />
                    <span class="uploadlab">{{state.disableBtn?'Uploading':'Upload'}}</span>
                </button>
                <button type="button" class="retake-btn btn-link" (click)="_helper.retakePhoto()"><span>Try
                        again</span></button>
            </div>
        </ng-container>

    </div>

</form>